import { useAuth } from '@components/Auth';
import { ImageRatio } from '@components/ImageThumbnailRatio/ImageRatio';
import VnrLink from '@components/VnrLink';
import { getBannerShow } from '@services/bannerAds.service';
import React, { useEffect, useState } from 'react';
import { isMobile } from 'react-device-detect-util';
import { useDispatch } from 'react-redux';
import { LOGIN_STATUS } from 'src/constants';

import styles from './BannerAds.module.scss';
import { TYPE_POSITION_CONFIG } from './bannerAdUtils';

const CommonGoogleAdBanner = ({ typePosition, style, showPopup}) => {
  const [bannerShow, setBannerShow] = useState();
  const styleAd = { ...TYPE_POSITION_CONFIG[typePosition].styles, ...style };
  const bannerImageRatio = TYPE_POSITION_CONFIG[typePosition].ratio;
  const configAds = TYPE_POSITION_CONFIG[typePosition];
  const { signed } = useAuth();
  const dispatch = useDispatch();

  const changeHostCloud = (src) => {
    if (!src) return null;

    if (!src.includes('s3-ap-southeast-1.amazonaws.com/agileops-gafv-dev-videos')) {
      return src;
    };

    return src.replace('s3-ap-southeast-1.amazonaws.com/agileops-gafv-dev-videos', 'd3gxgptuxgz1ri.cloudfront.net');
  };

  const callGetBannerShow = async (typePosition) => {
    const res = await getBannerShow(
      typePosition
    );

    if (res?.data?.content) {
      setBannerShow(res.data.content);
    };
    return;
  };

  useEffect(() => {
    if (!isMobile) {
      if (!TYPE_POSITION_CONFIG[typePosition].device_types.includes('desktop')) {
        return;
      }
    }
    if (isMobile) {
      if (!TYPE_POSITION_CONFIG[typePosition].device_types.includes('mobile')) {
        return undefined;
      }
    }
    callGetBannerShow(typePosition);
  }, [typePosition, configAds]);

  // Don't render anything until banner is loaded AND delay has passed
  if (!bannerShow || !showPopup) return null;

  // Special logic for banner slider popup with login check
  if (bannerShow.code === 'layout_popup_1685086898087') {
    if (signed !== LOGIN_STATUS.LOGGED_IN) {
      return (
        <div
          onClick={() => {
            dispatch.app.showPopupLogin({ positionLogin: 'BANNER_SLIDER' });
          }}
        >
          <div id={typePosition} className={`${configAds.code}`} style={styleAd}>
            <ImageRatio
              src={changeHostCloud(bannerShow.imageUrl)}
              ratio={bannerImageRatio}
              alt={bannerShow.code}
              className={styles.imageBanner}
            />
          </div>
        </div>
      );
    }

    return (
      <div id={typePosition} className={`${configAds.code}`} style={styleAd}>
        {configAds.adManager && (
          <div style={configAds.adManager.style} id={configAds.adManager.id}>
            <VnrLink
              id={bannerShow.code}
              to="/dashboard?banner=rebate"
              className="banner-ads bannervnrebate"
            >
              <ImageRatio
                src={changeHostCloud(bannerShow.imageUrl)}
                ratio={bannerImageRatio}
                alt={bannerShow.code}
                className={styles.imageBanner}
              />
            </VnrLink>
          </div>
        )}
      </div>
    );
  }

  // Default banner rendering
  return (
    <div id={typePosition} className={`${configAds.code}`} style={styleAd}>
      {configAds.adManager && (
        <div style={configAds.adManager.style} id={configAds.adManager.id}>
          <VnrLink
            id={bannerShow.code}
            to={bannerShow.url}
            className="banner-ads bannervnrebate"
          >
            <ImageRatio
              src={changeHostCloud(bannerShow.imageUrl)}
              ratio={bannerImageRatio}
              alt={bannerShow.code}
              className={styles.imageBanner}
            />
          </VnrLink>
        </div>
      )}
    </div>
  );
};

export default CommonGoogleAdBanner;
